import React, { useContext } from 'react'
import styles from './candidate.m.scss'
import clsx from 'clsx'
import { LocaleContext } from 'contexts/locale'
import messages from './candidate.locales.yml'

interface CandidateProps {
  candidateName: string
  avatarUrl?: string
  receivedVotes: number
  castVotes: number
  color: string
  isElected: boolean
}

/**
 * Renders a single candidate as a table row.
 *
 * @param {object} props
 * @param props.candidateName
 * @param props.avatarUrl
 * @param props.receivedVotes
 * @param props.castVotes
 * @param props.color
 * @param props.isElected
 * @return {XML}
 * @constructor
 */
export function Candidate({
  candidateName,
  avatarUrl,
  receivedVotes,
  castVotes,
  color = '#5A686D',
  isElected = false
}: CandidateProps) {
  const locale = useContext(LocaleContext)
  const localisedMessages = messages[locale]
  const numberFormatter = Intl.NumberFormat(locale + '-CH')
  const localisedCandidateName =
    candidateName === 'various'
      ? localisedMessages.variousCandidates
      : candidateName

  return (
    <tr className={clsx(styles.candidate, isElected && styles.elected)}>
      <td className={styles.avatarCell}>
        {avatarUrl && (
          <img
            style={{ borderColor: color }}
            src={avatarUrl}
            alt=''
            className={styles.avatarImage}
          />
        )}
      </td>
      <td className={styles.name}>{localisedCandidateName}</td>
      <td className={styles.chart}>
        <div className={styles.label}>
          {numberFormatter.format(receivedVotes)}
        </div>
        <div
          className={styles.bar}
          style={{
            backgroundColor: color,
            width: (receivedVotes / castVotes) * 100 + '%'
          }}
        />
      </td>
    </tr>
  )
}
